import { Directive, HostListener, ElementRef } from '@angular/core';

/**
 * Datepicker input mask will:
 * 1. add '/' automatically
 * 2. only allow numbers
 * 3. keep length to 10 characters
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[cfDatepickerInputMask]'
})
export class DatepickerInputMaskDirective {

  @HostListener('input', ['$event']) onInput(event) {
    let value = event.target.value;
    value = this.resetInput(value);
    value = this.removeCharacters(value);
    value = this.applyMask(value);
    value = this.formatDate(value);
    this.setInputValue(value);
    this.setCaretPosition(this.element.nativeElement, this.getInputLength(value));
  }

  constructor(private element: ElementRef) { }

  /**
   * Removes any previous formatting
   */
  private resetInput(value) {
    return value.replace(/\/+|_+/g, '');
  }

  /**
   * Set the value of the input
   */
  private setInputValue(value) {
    this.element.nativeElement.value = value;
  }

  /**
   * Removes all characters but numbers
   */
  private removeCharacters(value) {
    return value.toLowerCase().replace(/[^0-9\/_]/g, '');
  }

  /**
   * Apply the mask. Any empty fields will be
   * changed to underscore
   */
  private applyMask(value) {
    let mask = '________';
    mask = mask.slice(value.length);
    return value + mask;
  }

  /**
   * Formats numbers as date
   */
  private formatDate(date) {
    const dateValues = date.match(/(\w{2})(\w{2})(\w{4})/);
    return dateValues[1] + '/' + dateValues[2] + '/' + dateValues[3];
  }

  /**
   * Returns the length of the input without
   * underscores
   */
  private getInputLength(value) {
    return value.replace(/_+/g, '').length;
  }

  /**
   * Move the cursor to correct position
   */
  private setCaretPosition(elem, caretPos) {
    if (elem != null) {
      if (elem.createTextRange) {
        const range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else {
        if (elem.selectionStart) {
          elem.focus();
          elem.setSelectionRange(caretPos, caretPos);
        } else {
          elem.focus();
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker-input/datepicker-input-mask.directive.ts